import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import { handleHttp, getformitemsdata } from '@/utils/utils';
import listIcon from '@/assets/mapv2/eryuan/list-icon.svg';
const INTRO_FORM_ID = '165054';
const INTRO_FORM_USER_ID = '11882980853';
export default {
  name: 'eryuanIntro',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    // 地图 loading 结束后再弹出，避免被加载页遮挡
    mapReady: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listIcon,
      introVisible: false,
      placeName: '',
      introduce: '',
      bannerList: [],
      audioUrl: '',
      swiperEl: null,
      currentSlide: 0,
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      autoplayPending: false,
      dataReady: false,
      hasOpenedOnce: false,
      autoplayRetryTimer: null,
      autoplayRetryCount: 0,
      swiperTimer: null,
      unlockAudioBound: null
    };
  },
  computed: {
    rangeStyle() {
      const pct = this.duration > 0 ? this.currentTime / this.duration * 100 : 0;
      return {
        background: `linear-gradient(to right, #e75551 ${pct}%, rgba(0,0,0,0.1) ${pct}%)`
      };
    }
  },
  watch: {
    mapReady(val) {
      if (val) this.tryDefaultOpen();
    }
  },
  mounted() {
    this.bindAudioUnlock();
    this.fetchIntroData();
  },
  beforeUnmount() {
    this.unbindAudioUnlock();
    this.clearAutoplayRetry();
    this.clearSwiperTimer();
    this.destroySwiper();
    this.stopAudio();
  },
  methods: {
    sethandleHttp(url) {
      if (!url) return '';
      return handleHttp(url);
    },
    formatIntroduce(content) {
      if (!content) return '';
      return String(content).replace(/noteyd.chaoxing.com/g, location.protocol + '//noteyd.chaoxing.com');
    },
    formatTime(sec) {
      const s = Math.max(0, Math.floor(sec || 0));
      const m = Math.floor(s / 60);
      const r = s % 60;
      return `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
    },
    bindAudioUnlock() {
      if (this.unlockAudioBound) return;
      this.unlockAudioBound = () => {
        if (this.introVisible && this.audioUrl && this.autoplayPending) {
          this.doPlayAudio(true);
        }
      };
      document.addEventListener('touchstart', this.unlockAudioBound, {
        passive: true
      });
      document.addEventListener('click', this.unlockAudioBound, true);
    },
    unbindAudioUnlock() {
      if (!this.unlockAudioBound) return;
      document.removeEventListener('touchstart', this.unlockAudioBound);
      document.removeEventListener('click', this.unlockAudioBound, true);
      this.unlockAudioBound = null;
    },
    fetchIntroData() {
      const fid = this.$route.query.fid;
      this.$api.singleformUserId(fid, INTRO_FORM_ID, INTRO_FORM_USER_ID).then(res => {
        if (!res || !res.formUserList || res.formUserList.length === 0) {
          this.dataReady = true;
          this.tryDefaultOpen();
          return;
        }
        const formData = res.formUserList[0].formData || [];
        const formatData = {};
        formData.forEach(item => {
          formatData[item.alias] = getformitemsdata(item);
        });
        this.placeName = formatData.place_name || '洱源市简介';
        this.introduce = formatData.introduce || '';
        this.bannerList = Array.isArray(formatData.banner) ? formatData.banner : [];
        const audioList = formatData.audio;
        if (audioList && audioList.length > 0 && audioList[0].objectId) {
          this.$api.getUrlByObjectId(audioList[0].objectId).then(urlRes => {
            const raw = urlRes.http || '';
            this.audioUrl = raw ? handleHttp(raw) : '';
            this.dataReady = true;
            // 等 :src 落到 DOM 后立刻预加载，再尝试弹窗播放
            this.$nextTick(() => {
              this.preloadAudio();
              this.tryDefaultOpen();
            });
          }).catch(() => {
            this.dataReady = true;
            this.tryDefaultOpen();
          });
        } else {
          this.dataReady = true;
          this.tryDefaultOpen();
        }
      }).catch(() => {
        this.dataReady = true;
        this.tryDefaultOpen();
      });
    },
    tryDefaultOpen() {
      if (this.hasOpenedOnce) return;
      if (!this.dataReady || !this.mapReady) return;
      this.hasOpenedOnce = true;
      this.openIntro(true);
    },
    openIntro(autoplay = true) {
      const shouldAutoplay = autoplay !== false;
      this.introVisible = true;
      this.autoplayPending = shouldAutoplay;
      this.autoplayRetryCount = 0;
      this.pauseMapBgm();
      // 按钮点击：同步 play 保留用户手势；已预加载则可立即出声
      if (shouldAutoplay && this.audioUrl) {
        this.tryAutoPlay(true);
      }
      this.$nextTick(() => {
        this.preloadAudio();
        if (this.autoplayPending && this.audioUrl) {
          this.tryAutoPlay(false);
        }
        // swiper 与音频解耦，避免抢首包带宽后再拖慢播放时机
        setTimeout(() => {
          this.initSwiper();
        }, 150);
      });
    },
    closeIntro() {
      this.introVisible = false;
      this.autoplayPending = false;
      this.clearAutoplayRetry();
      this.clearSwiperTimer();
      this.destroySwiper();
      this.stopAudio();
    },
    pauseMapBgm() {
      const bg = document.getElementById('bgaudio');
      if (bg && !bg.paused) {
        try {
          bg.pause();
        } catch (e) {/* ignore */}
      }
    },
    clearSwiperTimer() {
      if (this.swiperTimer) {
        clearInterval(this.swiperTimer);
        this.swiperTimer = null;
      }
    },
    initSwiper() {
      this.destroySwiper();
      this.clearSwiperTimer();
      if (!this.$refs.swipercontainer || this.bannerList.length === 0) return;
      this.currentSlide = 0;
      const multi = this.bannerList.length > 1;
      // Swiper5：少图不用 loop，避免初始化异常；用定时 slideNext 保底自动轮播
      this.swiperEl = new Swiper(this.$refs.swipercontainer, {
        initialSlide: 0,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        loop: false,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        allowTouchMove: true,
        autoplay: false,
        on: {
          slideChange: () => {
            if (!this.swiperEl) return;
            this.currentSlide = this.swiperEl.realIndex;
          }
        }
      });
      this.$nextTick(() => {
        if (!this.swiperEl) return;
        try {
          this.swiperEl.update();
          this.swiperEl.updateSize();
          this.swiperEl.updateSlides();
        } catch (e) {/* ignore */}
        if (multi) {
          this.swiperTimer = setInterval(() => {
            if (!this.swiperEl || !this.introVisible) return;
            const total = this.bannerList.length;
            const next = (this.swiperEl.activeIndex + 1) % total;
            this.swiperEl.slideTo(next);
          }, 3000);
        }
      });
    },
    destroySwiper() {
      this.clearSwiperTimer();
      if (this.swiperEl) {
        try {
          this.swiperEl.destroy(true, true);
        } catch (e) {/* ignore */}
        this.swiperEl = null;
      }
    },
    clearAutoplayRetry() {
      if (this.autoplayRetryTimer) {
        clearTimeout(this.autoplayRetryTimer);
        this.autoplayRetryTimer = null;
      }
    },
    /** 拿到 URL 后尽早缓冲，减少弹窗打开后再等下载 */
    preloadAudio() {
      const el = this.$refs.audioEl;
      if (!el || !this.audioUrl) return;
      try {
        if (el.readyState < 2) el.load();
      } catch (e) {/* ignore */}
    },
    isAudioReady() {
      const el = this.$refs.audioEl;
      // HAVE_CURRENT_DATA = 2
      return !!(el && el.src && el.readyState >= 2);
    },
    onAudioCanPlay() {
      if (this.autoplayPending && this.introVisible && !this.isPlaying) {
        this.doPlayAudio(true);
      }
    },
    /**
     * @param {boolean} immediate 同步调用（保留点击手势）；否则优先等 canplay
     */
    tryAutoPlay(immediate = false) {
      if (!this.audioUrl) return;
      this.autoplayPending = true;
      this.autoplayRetryCount = 0;
      this.unlockWechatAudio();
      if (immediate || this.isAudioReady()) {
        this.doPlayAudio(true);
      }
      // 短兜底：不再盲等 1～2s，主路径交给 canplay
      ;
      [120, 400].forEach(ms => {
        setTimeout(() => {
          if (this.autoplayPending && this.introVisible && !this.isPlaying) {
            this.unlockWechatAudio();
            this.doPlayAudio(this.isAudioReady());
          }
        }, ms);
      });
    },
    /** 微信内用 getNetworkType 回调解锁有声播放 */
    unlockWechatAudio() {
      const playInBridge = () => {
        try {
          if (typeof window.WeixinJSBridge === 'undefined') {
            this.doPlayAudio(this.isAudioReady());
            return;
          }
          window.WeixinJSBridge.invoke('getNetworkType', {}, () => {
            this.doPlayAudio(true);
          });
        } catch (e) {
          this.doPlayAudio(this.isAudioReady());
        }
      };
      if (typeof window.WeixinJSBridge !== 'undefined') {
        playInBridge();
      } else {
        document.addEventListener('WeixinJSBridgeReady', playInBridge, {
          once: true
        });
      }
    },
    doPlayAudio(force = false) {
      const el = this.$refs.audioEl;
      if (!el || !this.audioUrl || !this.introVisible) return;
      if (!el.paused && !el.ended) {
        this.isPlaying = true;
        this.autoplayPending = false;
        this.clearAutoplayRetry();
        return;
      }
      // 未缓冲好时不盲目 play（易失败后拖到秒级重试）；等 canplay
      if (!force && el.readyState < 2) {
        this.preloadAudio();
        return;
      }
      const p = el.play();
      if (p && typeof p.then === 'function') {
        p.then(() => {
          this.isPlaying = true;
          this.autoplayPending = false;
          this.clearAutoplayRetry();
        }).catch(() => {
          this.isPlaying = false;
          this.scheduleAutoplayRetry();
        });
      }
    },
    scheduleAutoplayRetry() {
      if (!this.autoplayPending || !this.introVisible) return;
      if (this.autoplayRetryCount >= 3) return;
      this.clearAutoplayRetry();
      this.autoplayRetryCount += 1;
      this.autoplayRetryTimer = setTimeout(() => {
        if (this.autoplayPending && this.introVisible && !this.isPlaying) {
          this.doPlayAudio(this.isAudioReady());
        }
      }, 200 * this.autoplayRetryCount);
    },
    toggleAudio() {
      const el = this.$refs.audioEl;
      if (!el || !this.audioUrl) return;
      if (this.isPlaying) {
        el.pause();
        this.autoplayPending = false;
      } else {
        this.autoplayPending = false;
        el.play().catch(() => {
          this.isPlaying = false;
        });
      }
    },
    stopAudio() {
      const el = this.$refs.audioEl;
      if (!el) return;
      try {
        el.pause();
        el.currentTime = 0;
      } catch (e) {/* ignore */}
      this.isPlaying = false;
      this.currentTime = 0;
    },
    onTimeUpdate(e) {
      this.currentTime = e.target.currentTime || 0;
    },
    onLoadedMeta(e) {
      this.duration = e.target.duration || 0;
    },
    onAudioEnded() {
      this.isPlaying = false;
      this.currentTime = 0;
      this.autoplayPending = false;
    },
    onSeek(e) {
      const el = this.$refs.audioEl;
      const val = Number(e.target.value);
      if (el && !Number.isNaN(val)) {
        el.currentTime = val;
        this.currentTime = val;
      }
    }
  }
};